// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"e70bedc5","856":"c06a0e3e","993":"e89f0668"}[chunkId] + ".chunk.js";
};